"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

/**
 * A class to represent the the options that are passed to MwChartOneSeriesBarOptions.onBarClick
 * @param {object} options - Internal use
 *
 * @property {string} key - The key of the bar that was clicked
 * @property {number} value - The value of the bar that was clicked
 *
 */
var BarClickEvent = function BarClickEvent(_ref) {
  var key = _ref.key,
      value = _ref.value;
  (0, _classCallCheck2.default)(this, BarClickEvent);

  if (key === undefined) {
    throw new TypeError('key cannot be undefined');
  }

  if (typeof value !== 'number') {
    throw new TypeError("value must be a number. Provided value: ".concat(value));
  }

  this.key = key;
  this.value = value;
};

exports.default = BarClickEvent;